import type { FaireProductEntity } from "../../entity_types/product";

export const p_k78s256van: FaireProductEntity = {
  token: "p_k78s256van",
  type: "product",
  name: "Ube Cookie Creme Pie™ (V)",
  brandToken: "b_4xhf67vcvr",
  brandName: "Out The Dough",
  imageUrl:
    "https://cdn.faire.com/fastly/089a9fb195844f5fdc6e889a843a6ca4db008a5feb0db83d545b663001ec6e86.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20e0ce1586697f587d6bd1555da0e667f5ac0865f223c82a5ebda28d990998a5.png",
    "https://cdn.faire.com/fastly/e87752a87f531c7b759f19cbbf5d2e729bf18a844c400ba91bef2c36463c959b.png",
  ],
  priceDollars: 4.97,
  description:
    "Ube Creme Pie - Vegan Buttercreme Sandwiched Between Two Ube Cookies. (Contains: Wheat & Soy; DELICIOUSLY VEGAN). Made in small batches in California's East Bay - from scratch since 2017. Made with heat-treated, pastuerized products - with zero preservatives, artificial dyes or additives. With a mission to create delectable cookie dough treats everyone can enjoy, you can treat yourself to something truly satisfying!",
  tags: [],
  msrpDollars: 8.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:46.719Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
